import { Currency } from '@/core/currency/interfaces';

const UGX: Currency = {
    name: 'Ugandan Shilling',
    demonym: 'Ugandan',
    majorSingle: 'Shilling',
    majorPlural: 'Shillings',
    codeNumeric: '800',
    symbol: 'USh',
    symbolNative: 'Sh',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'UGX',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default UGX;
